import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, toDisplayString as _toDisplayString, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, createTextVNode as _createTextVNode, withModifiers as _withModifiers } from "vue"
import _imports_0 from '../../../assets/icons/folder.png'
import _imports_1 from '../../../assets/icons/file-colored.png'


const _hoisted_1 = { class: "step-form-container" }
const _hoisted_2 = {
  key: 0,
  class: "step-1-container"
}
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { class: "notice mb-8 text-2xl text-gray-500" }, " İlk aşamada, projenizin adını ve projeye başlangıçta katılacak kişileri belirleyin. Kişileri daha sonra da ekleyip çıkartabileceksiniz. Projeye kendinizi eklemenize gerek yok, projeyi oluşturan kişi olduğunuz için otomatik olarak ekleneceksiniz. ", -1)
const _hoisted_4 = { class: "ac-form-control" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("label", { for: "name" }, "Proje Adı", -1)
const _hoisted_6 = { class: "ac-form-control" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("label", { for: "users" }, "Üyeler", -1)
const _hoisted_8 = {
  key: 1,
  class: "step-2-container"
}
const _hoisted_9 = { class: "ac-form-control" }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("label", { class: "text-3xl font-bold text-center mb-4" }, "Veri Kaynağı Türü", -1)
const _hoisted_11 = /*#__PURE__*/_createElementVNode("div", { class: "notice mb-8 text-2xl text-gray-500" }, " Projeniz için hangi türde bir veri kaynağı kullanmak istediğinizi seçin. Tek bir dosya üzerinde çalışabilir veya bütün bir klasörü kullanabilirsiniz. ", -1)
const _hoisted_12 = { class: "selection-options grid grid-cols-1 md:grid-cols-2 gap-6 mt-6" }
const _hoisted_13 = /*#__PURE__*/_createElementVNode("div", { class: "flex items-center mb-4" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_0,
    alt: "folder",
    class: "w-12 h-12 mr-4"
  }),
  /*#__PURE__*/_createElementVNode("h3", { class: "text-xl font-semibold" }, "Klasör")
], -1)
const _hoisted_14 = /*#__PURE__*/_createElementVNode("p", { class: "text-gray-600" }, " Bir klasör seçin ve içindeki tüm dosyaları projenizde kullanın. Bu seçenek, bütün bir projenin tüm belgelerini kullanmak için idealdir. ", -1)
const _hoisted_15 = [
  _hoisted_13,
  _hoisted_14
]
const _hoisted_16 = /*#__PURE__*/_createElementVNode("div", { class: "flex items-center mb-4" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_1,
    alt: "file",
    class: "w-12 h-12 mr-4"
  }),
  /*#__PURE__*/_createElementVNode("h3", { class: "text-xl font-semibold" }, "Tek Dosya")
], -1)
const _hoisted_17 = /*#__PURE__*/_createElementVNode("p", { class: "text-gray-600" }, " Belirli bir dosya seçin ve sadece o dosya üzerinde çalışın. Tek bir dosyayı derinlemesine incelemek için bu seçeneği kullanın. ", -1)
const _hoisted_18 = [
  _hoisted_16,
  _hoisted_17
]
const _hoisted_19 = {
  key: 2,
  class: "step-3-container"
}
const _hoisted_20 = { class: "ac-form-control" }
const _hoisted_21 = {
  class: "text-3xl font-bold text-center mb-4",
  for: "infoBase"
}
const _hoisted_22 = {
  key: 0,
  class: "text-center py-4"
}
const _hoisted_23 = { class: "border rounded p-3 max-h-60 flex items-center justify-center" }
const _hoisted_24 = {
  key: 1,
  class: "text-center py-4"
}
const _hoisted_25 = {
  key: 2,
  class: "selection-container"
}
const _hoisted_26 = { class: "flex items-center justify-between mb-6" }
const _hoisted_27 = { class: "breadcrumbs flex items-center gap-1" }
const _hoisted_28 = ["onClick"]
const _hoisted_29 = {
  key: 0,
  class: "mx-1"
}
const _hoisted_30 = { class: "item-list border rounded p-3 max-h-60 overflow-y-auto" }
const _hoisted_31 = { key: 0 }
const _hoisted_32 = {
  key: 0,
  class: "text-center py-2 text-gray-500"
}
const _hoisted_33 = { key: 1 }
const _hoisted_34 = ["onDblclick"]
const _hoisted_35 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: "folder",
  class: "w-10 h-10 mr-8"
}, null, -1)
const _hoisted_36 = ["onDblclick"]
const _hoisted_37 = ["onClick"]
const _hoisted_38 = { key: 1 }
const _hoisted_39 = {
  key: 0,
  class: "text-center py-2 text-gray-500"
}
const _hoisted_40 = { key: 1 }
const _hoisted_41 = ["onDblclick"]
const _hoisted_42 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: "folder",
  class: "w-10 h-10 mr-8"
}, null, -1)
const _hoisted_43 = ["onDblclick"]
const _hoisted_44 = /*#__PURE__*/_createElementVNode("span", { class: "text-gray-400 text-lg" }, "(Klasör)", -1)
const _hoisted_45 = ["alt"]
const _hoisted_46 = { class: "flex-grow" }
const _hoisted_47 = ["onClick"]
const _hoisted_48 = /*#__PURE__*/_createElementVNode("p", { class: "text-gray-500 text-lg mt-4" }, " AI sistemimiz şu anda yalnızca PDF, Word, Excel, Google Docs ve Google Sheets dosyalarını desteklemektedir. Sadece bu dosyaları göreceksiniz. ", -1)
const _hoisted_49 = {
  key: 0,
  class: "selected-item mt-3 p-3 bg-green-50 border border-green-200 rounded"
}
const _hoisted_50 = { class: "font-medium" }
const _hoisted_51 = { key: 0 }
const _hoisted_52 = { key: 1 }
const _hoisted_53 = { key: 2 }
const _hoisted_54 = { class: "button-row flex gap-8 justify-center mt-4" }
const _hoisted_55 = ["disabled"]

import { ref, reactive, onMounted } from 'vue'
import firebase from "@/firebase"
import VueMultiselect from 'vue-multiselect'
import { useStore } from 'vuex'
import acLoader from '../../../components/reusable/acLoader.vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'stepCreateProjectForm',
  emits: ['cancelled', 'submitted'],
  setup(__props, { emit: __emit }) {

const store = useStore()

const currentStep = ref(1)
const newProject = reactive({
    name: '',
    members: [],
    infoBase: "",
    infoBaseType: "folder", // "folder" or "file"
    isClosed: false,
    createdAt: new Date(),
})

// Added state for Google Drive integration
const isLoadingDrive = ref(true)
const driveInitialized = ref(false)
const folders = ref([])
const files = ref([])
const currentFolderId = ref('root')
const folderBreadcrumbs = ref([{ id: 'root', name: 'My Drive' }])

// Get the composable result
const isLoadingUsers = ref(false)
const users = ref([])

const emits = __emit

const emitCancelled = () => {
    emits('cancelled')
}

const emitSubmitted = () => {
    // Create a copy of the project with only member IDs
    const projectToSubmit = {
        ...newProject,
        members: newProject.members.map(member => { return {
          id: member.id,
          name: member.fullName
        }})
    }
    emits('submitted', projectToSubmit)
}

const getusers = async () => {
    isLoadingUsers.value = true
    const db = firebase.firestore().collection("team")
    const snapshot = await db.get()
    
    // Create a new array instead of pushing to the existing one
    const newUsers = []
    snapshot.docs.forEach((doc) => {
        console.log(doc.id)
        const firstName = doc.data().name.first
        const lastName = doc.data().name.last
        newUsers.push({
            id: doc.id,
            firstName: firstName,
            lastName: lastName,
            fullName: `${firstName} ${lastName}`
        })
    })
    
    // Replace the entire array at once for better reactivity
    users.value = newUsers
    isLoadingUsers.value = false
}

// Load GAPI Script
function loadGapiScript() {
  return new Promise((resolve, reject) => {
    const script = document.createElement('script');
    script.src = 'https://apis.google.com/js/api.js';
    script.async = true;
    script.defer = true;
    script.onload = () => resolve(null);
    script.onerror = () => reject(new Error('Failed to load Google API client'));
    document.head.appendChild(script);
  });
}

// Function to initialize Drive and check for existing permissions
async function initializeDrive() {
  isLoadingDrive.value = true;
  
  try {
    // Get access token from Firebase
    const accessToken = await store.dispatch('user/requestGoogleDriveAccess');
    
    // Initialize Drive API with token
    await initGapiClient(accessToken);
    
    // Load initial folders/files based on selection
    if (newProject.infoBaseType === 'folder') {
      await loadFolders('root');
    } else {
      await loadFiles('root');
    }
    
    driveInitialized.value = true;
  } catch (error) {
    console.error('Failed to initialize Google Drive:', error);
    // Show user-friendly error message
    if (error.message !== 'User cancelled') {
      alert('Google Drive bağlantısı kurulamadı. Lütfen tekrar deneyin.');
    }
  } finally {
    isLoadingDrive.value = false;
  }
}

// Initialize Drive API client with token
async function initGapiClient(accessToken) {
  try {
    // Load GAPI if not already loaded
    if (!window.gapi) {
      await loadGapiScript();
    }
    
    return new Promise((resolve, reject) => {
      window.gapi.load('client', async () => {
        try {
          // Initialize client with proper OAuth scopes
          await window.gapi.client.init({
            clientId: '125219650343-l311uaub3gc76nhbumo65cj0eav3ccr2.apps.googleusercontent.com',
            discoveryDocs: ['https://www.googleapis.com/discovery/v1/apis/drive/v3/rest']
          });
          
          // Set the access token
          window.gapi.client.setToken({ access_token: accessToken });
          
          resolve(window.gapi.client.drive);
        } catch (error) {
          console.error('Error initializing GAPI client:', error);
          reject(error);
        }
      });
    });
  } catch (error) {
    console.error('Failed to initialize GAPI client:', error);
    throw error;
  }
}

// Function to load folders from a specific parent folder
async function loadFolders(folderId) {
  isLoadingDrive.value = true;
  currentFolderId.value = folderId;
  
  try {
    // Make sure we have a valid access token
    if (!window.gapi.client.getToken()) {
      // If token is missing, reinitialize
      const accessToken = await store.dispatch('user/requestGoogleDriveAccess');
      window.gapi.client.setToken({ access_token: accessToken });
    }

    const response = await window.gapi.client.drive.files.list({
      q: `mimeType='application/vnd.google-apps.folder' and '${folderId}' in parents and trashed=false`,
      supportsAllDrives: true,
      spaces: 'drive',
      fields: 'files(id, name)',
    });
    
    folders.value = response.result.files;
    
    // Update breadcrumbs if not root
    if (folderId !== 'root') {
      // Get folder details for breadcrumb
      const folderResponse = await window.gapi.client.drive.files.get({
        fileId: folderId,
        readOnly: true,
        q: 'id, name',
        fields: 'id, name'
      });
      
      // Check if this folder is already in breadcrumbs (going back)
      const existingIndex = folderBreadcrumbs.value.findIndex(crumb => crumb.id === folderId);
      if (existingIndex >= 0) {
        // Truncate breadcrumbs up to this point
        folderBreadcrumbs.value = folderBreadcrumbs.value.slice(0, existingIndex + 1);
      } else {
        // Add to breadcrumbs
        folderBreadcrumbs.value.push({
          id: folderResponse.result.id,
          name: folderResponse.result.name
        });
      }
    } else {
      // Reset breadcrumbs for root
      folderBreadcrumbs.value = [{ id: 'root', name: 'My Drive' }];
    }
  } catch (error) {
    console.error('Error loading folders:', error);
    // If we get an authentication error, try to reinitialize
    if (error.status === 401) {
      try {
        const accessToken = await store.dispatch('user/requestGoogleDriveAccess');
        window.gapi.client.setToken({ access_token: accessToken });
        // Retry the operation
        return loadFolders(folderId);
      } catch (retryError) {
        console.error('Failed to reauthenticate:', retryError);
      }
    }
  } finally {
    isLoadingDrive.value = false;
  }
}

// Function to load files from a specific parent folder
async function loadFiles(folderId) {
  isLoadingDrive.value = true;
  currentFolderId.value = folderId;
  try {
    // Make sure we have a valid access token
    if (!window.gapi.client.getToken()) {
      // If token is missing, reinitialize
      const accessToken = await store.dispatch('user/requestGoogleDriveAccess');
      window.gapi.client.setToken({ access_token: accessToken });
    }
    // Fetch folders
    const foldersResponse = await window.gapi.client.drive.files.list({
      q: `mimeType='application/vnd.google-apps.folder' and '${folderId}' in parents and trashed=false`,
      supportsAllDrives: true,
      spaces: 'drive',
      fields: 'files(id, name)',
    });
    folders.value = foldersResponse.result.files;
    // Fetch files
    const filesResponse = await window.gapi.client.drive.files.list({
      q: `'${folderId}' in parents and trashed=false and mimeType!='application/vnd.google-apps.folder' and (mimeType='application/pdf' or mimeType='application/vnd.openxmlformats-officedocument.wordprocessingml.document' or mimeType='application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' or mimeType='application/vnd.google-apps.document' or mimeType='application/vnd.google-apps.spreadsheet')`,
      supportsAllDrives: true,
      spaces: 'drive',
      fields: 'files(id, name, mimeType)',
    });
    files.value = filesResponse.result.files;
    // Update breadcrumbs if not root
    if (folderId !== 'root') {
      const folderResponse = await window.gapi.client.drive.files.get({
        fileId: folderId,
        readOnly: true,
        q: 'id, name',
        fields: 'id, name'
      });
      const existingIndex = folderBreadcrumbs.value.findIndex(crumb => crumb.id === folderId);
      if (existingIndex >= 0) {
        folderBreadcrumbs.value = folderBreadcrumbs.value.slice(0, existingIndex + 1);
      } else {
        folderBreadcrumbs.value.push({
          id: folderResponse.result.id,
          name: folderResponse.result.name
        });
      }
    } else {
      folderBreadcrumbs.value = [{ id: 'root', name: 'My Drive' }];
    }
  } catch (error) {
    console.error('Error loading files:', error);
    if (error.status === 401) {
      try {
        const accessToken = await store.dispatch('user/requestGoogleDriveAccess');
        window.gapi.client.setToken({ access_token: accessToken });
        return loadFiles(folderId);
      } catch (retryError) {
        console.error('Failed to reauthenticate:', retryError);
      }
    }
  } finally {
    isLoadingDrive.value = false;
  }
}

// Function to select a folder as the info base
function selectFolder(folder) {
  newProject.infoBase = folder.id;
}

// Function to select a file as the info base
function selectFile(file) {
  newProject.infoBase = file.id;
}

// Function to go to next step
function nextStep() {
  if (currentStep.value === 1) {
    currentStep.value = 2;
  } else if (currentStep.value === 2) {
    currentStep.value = 3;
    // Initialize Drive when moving to step 3
    initializeDrive();
  }
}

// Function to go back
function prevStep() {
  if (currentStep.value > 1) {
    currentStep.value--;
  }
}

// Function to go to parent folder
function goToParentFolder() {
  if (folderBreadcrumbs.value.length > 1) {
    const parentId = folderBreadcrumbs.value[folderBreadcrumbs.value.length - 2].id;
    if (newProject.infoBaseType === 'folder') {
      loadFolders(parentId);
    } else {
      loadFiles(parentId);
    }
  }
}

onMounted(async () => {
  await getusers();
  console.log(users.value);
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("form", {
      class: "ac-main-form !border-none !shadow-none",
      onSubmit: _withModifiers(emitSubmitted, ["prevent"])
    }, [
      (currentStep.value === 1)
        ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
            _hoisted_3,
            _createElementVNode("div", _hoisted_4, [
              _hoisted_5,
              _withDirectives(_createElementVNode("input", {
                required: "",
                type: "text",
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((newProject.name) = $event))
              }, null, 512), [
                [_vModelText, newProject.name]
              ])
            ]),
            _createElementVNode("div", _hoisted_6, [
              _hoisted_7,
              (!isLoadingUsers.value)
                ? (_openBlock(), _createBlock(_unref(VueMultiselect), {
                    key: 0,
                    class: "w-full border",
                    modelValue: newProject.members,
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((newProject.members) = $event)),
                    search: "",
                    historyButton: "",
                    historyButtonText: "Geri Al",
                    searchPlaceholder: "Arama",
                    btnClass: "multi-select__button",
                    multiple: true,
                    options: users.value,
                    "track-by": "id",
                    label: "fullName",
                    placeholder: "Lütfen eklemek istediğiniz kişileri seçin",
                    selectLabel: "Seçmek için tıklayın",
                    selectedLabel: "Seçildi",
                    deselectLabel: "Kaldır"
                  }, null, 8, ["modelValue", "options"]))
                : _createCommentVNode("", true)
            ])
          ]))
        : _createCommentVNode("", true),
      (currentStep.value === 2)
        ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
            _createElementVNode("div", _hoisted_9, [
              _hoisted_10,
              _hoisted_11,
              _createElementVNode("div", _hoisted_12, [
                _createElementVNode("div", {
                  class: _normalizeClass(["option-card p-6 border-2 rounded-lg cursor-pointer transition-all duration-200", newProject.infoBaseType === 'folder' ? 'border-blue-500 bg-blue-50' : 'border-gray-300 hover:border-gray-400']),
                  onClick: _cache[2] || (_cache[2] = ($event: any) => (newProject.infoBaseType = 'folder'))
                }, _hoisted_15, 2),
                _createElementVNode("div", {
                  class: _normalizeClass(["option-card p-6 border-2 rounded-lg cursor-pointer transition-all duration-200", newProject.infoBaseType === 'file' ? 'border-blue-500 bg-blue-50' : 'border-gray-300 hover:border-gray-400']),
                  onClick: _cache[3] || (_cache[3] = ($event: any) => (newProject.infoBaseType = 'file'))
                }, _hoisted_18, 2)
              ])
            ])
          ]))
        : _createCommentVNode("", true),
      (currentStep.value === 3)
        ? (_openBlock(), _createElementBlock("div", _hoisted_19, [
            _createElementVNode("div", _hoisted_20, [
              _createElementVNode("label", _hoisted_21, _toDisplayString(newProject.infoBaseType === 'folder' ? 'Klasör' : 'Dosya') + " Seçimi ", 1),
              (isLoadingDrive.value)
                ? (_openBlock(), _createElementBlock("div", _hoisted_22, [
                    _createElementVNode("div", _hoisted_23, [
                      _createVNode(acLoader, {
                        class: "top-24",
                        loaderHeight: 200
                      })
                    ])
                  ]))
                : (!driveInitialized.value)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_24, [
                      _createElementVNode("button", {
                        type: "button",
                        class: "ac-primary-button",
                        onClick: initializeDrive
                      }, " Google Drive'a Bağlan ")
                    ]))
                  : (_openBlock(), _createElementBlock("div", _hoisted_25, [
                      _createElementVNode("div", _hoisted_26, [
                        _createElementVNode("div", _hoisted_27, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(folderBreadcrumbs.value, (crumb, index) => {
                            return (_openBlock(), _createElementBlock("span", {
                              key: crumb.id,
                              class: "cursor-pointer hover:underline",
                              onClick: ($event: any) => (newProject.infoBaseType === 'folder' ? loadFolders(crumb.id) : loadFiles(crumb.id))
                            }, [
                              _createTextVNode(_toDisplayString(crumb.name) + " ", 1),
                              (index < folderBreadcrumbs.value.length - 1)
                                ? (_openBlock(), _createElementBlock("span", _hoisted_29, "/"))
                                : _createCommentVNode("", true)
                            ], 8, _hoisted_28))
                          }), 128))
                        ]),
                        (folderBreadcrumbs.value.length > 1)
                          ? (_openBlock(), _createElementBlock("button", {
                              key: 0,
                              type: "button",
                              class: "ac-secondary-button text-lg px-4 py-2",
                              onClick: goToParentFolder
                            }, " ← Üst Klasöre Dön "))
                          : _createCommentVNode("", true)
                      ]),
                      _createElementVNode("div", _hoisted_30, [
                        (newProject.infoBaseType === 'folder')
                          ? (_openBlock(), _createElementBlock("div", _hoisted_31, [
                              (folders.value.length === 0)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_32, " Bu klasörde herhangi bir alt klasör bulunmuyor. "))
                                : (_openBlock(), _createElementBlock("div", _hoisted_33, [
                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(folders.value, (folder) => {
                                      return (_openBlock(), _createElementBlock("div", {
                                        key: folder.id,
                                        onDblclick: ($event: any) => (loadFolders(folder.id)),
                                        class: "item flex text-3xl py-4 items-center p-2 hover:bg-gray-100 rounded cursor-pointer"
                                      }, [
                                        _hoisted_35,
                                        _createElementVNode("span", {
                                          class: "flex-grow",
                                          onDblclick: ($event: any) => (loadFolders(folder.id))
                                        }, _toDisplayString(folder.name), 41, _hoisted_36),
                                        _createElementVNode("button", {
                                          type: "button",
                                          class: "text-2xl hover:text-green-700",
                                          onClick: ($event: any) => (selectFolder(folder))
                                        }, " Seç ", 8, _hoisted_37)
                                      ], 40, _hoisted_34))
                                    }), 128))
                                  ]))
                            ]))
                          : (newProject.infoBaseType === 'file')
                            ? (_openBlock(), _createElementBlock("div", _hoisted_38, [
                                (folders.value.length === 0 && files.value.length === 0)
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_39, " Bu klasörde uygun bir dosya veya alt klasör bulunmuyor. "))
                                  : (_openBlock(), _createElementBlock("div", _hoisted_40, [
                                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(folders.value, (folder) => {
                                        return (_openBlock(), _createElementBlock("div", {
                                          key: 'folder-' + folder.id,
                                          onDblclick: ($event: any) => (loadFiles(folder.id)),
                                          class: "item flex text-3xl py-4 items-center p-2 hover:bg-gray-100 rounded cursor-pointer"
                                        }, [
                                          _hoisted_42,
                                          _createElementVNode("span", {
                                            class: "flex-grow",
                                            onDblclick: ($event: any) => (loadFiles(folder.id))
                                          }, _toDisplayString(folder.name), 41, _hoisted_43),
                                          _hoisted_44
                                        ], 40, _hoisted_41))
                                      }), 128)),
                                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(files.value, (file) => {
                                        return (_openBlock(), _createElementBlock("div", {
                                          key: 'file-' + file.id,
                                          class: "item flex text-3xl py-4 items-center p-2 hover:bg-gray-100 rounded cursor-pointer"
                                        }, [
                                          _createElementVNode("img", {
                                            src: _imports_1,
                                            alt: file.name,
                                            class: "w-10 h-10 mr-8"
                                          }, null, 8, _hoisted_45),
                                          _createElementVNode("span", _hoisted_46, _toDisplayString(file.name), 1),
                                          _createElementVNode("button", {
                                            type: "button",
                                            class: "text-2xl hover:text-green-700",
                                            onClick: ($event: any) => (selectFile(file))
                                          }, " Seç ", 8, _hoisted_47)
                                        ]))
                                      }), 128))
                                    ]))
                              ]))
                            : _createCommentVNode("", true)
                      ]),
                      _hoisted_48,
                      (newProject.infoBase)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_49, [
                            _createElementVNode("div", _hoisted_50, "Seçilen " + _toDisplayString(newProject.infoBaseType === 'folder' ? 'Klasör' : 'Dosya') + ":", 1),
                            (newProject.infoBaseType === 'folder' && folders.value.find(f => f.id === newProject.infoBase))
                              ? (_openBlock(), _createElementBlock("div", _hoisted_51, _toDisplayString(folders.value.find(f => f.id === newProject.infoBase).name), 1))
                              : (newProject.infoBaseType === 'file' && files.value.find(f => f.id === newProject.infoBase))
                                ? (_openBlock(), _createElementBlock("div", _hoisted_52, _toDisplayString(files.value.find(f => f.id === newProject.infoBase).name), 1))
                                : (folderBreadcrumbs.value.length > 0 && folderBreadcrumbs.value[folderBreadcrumbs.value.length - 1].id === newProject.infoBase)
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_53, _toDisplayString(folderBreadcrumbs.value[folderBreadcrumbs.value.length - 1].name), 1))
                                  : _createCommentVNode("", true)
                          ]))
                        : _createCommentVNode("", true)
                    ]))
            ])
          ]))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_54, [
        (currentStep.value > 1)
          ? (_openBlock(), _createElementBlock("button", {
              key: 0,
              type: "button",
              class: "ac-secondary-button",
              onClick: prevStep
            }, "Geri"))
          : _createCommentVNode("", true),
        (currentStep.value === 1)
          ? (_openBlock(), _createElementBlock("button", {
              key: 1,
              type: "button",
              class: "ac-secondary-button",
              onClick: emitCancelled
            }, "İptal"))
          : _createCommentVNode("", true),
        (currentStep.value === 1)
          ? (_openBlock(), _createElementBlock("button", {
              key: 2,
              type: "button",
              class: "ac-primary-button",
              onClick: nextStep
            }, "Devam Et"))
          : _createCommentVNode("", true),
        (currentStep.value === 2)
          ? (_openBlock(), _createElementBlock("button", {
              key: 3,
              type: "button",
              class: "ac-primary-button",
              onClick: nextStep
            }, "Seçim Yap"))
          : _createCommentVNode("", true),
        (currentStep.value === 3)
          ? (_openBlock(), _createElementBlock("button", {
              key: 4,
              type: "submit",
              class: "ac-primary-button",
              disabled: !newProject.infoBase
            }, "Oluştur", 8, _hoisted_55))
          : _createCommentVNode("", true)
      ])
    ], 32)
  ]))
}
}

})